
export const BANK_TRANSFER_THRESHOLD = 25000;
export const BANK_IBAN = 'SA1180000611608016301369';
